import { ComponentType } from 'react'
import { FormattedMessage } from 'react-intl'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-top: 40px;
  padding-bottom: 24px;

  ${up('sm')} {
    padding-top: 88px;
    padding-bottom: 64px;
  }
`

const Suptitle = styled.h6`
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  color: #0078c9;
  line-height: 18px;

  ${up('sm')} {
    margin-bottom: 14px;
  }
`

const Title = styled.h1`
  font-weight: bold;
  font-size: 23px;
  line-height: 38px;

  ${up('sm')} {
    font-size: 26px;
    line-height: 33px;
  }
`

const Subtitle = styled.p`
  margin: 0;
  color: #22262a;
  font-size: 16px;
  line-height: 24px;

  ${up('sm')} {
    font-size: 17px;
    line-height: 26px;
  }
`

interface Props {
  zone: any
}

export const Hero: ComponentType<Props> = ({ zone }) => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <Suptitle>
            <FormattedMessage id="explore.zone.suptitle" values={{ zone: zone.name }} />
          </Suptitle>
          <Title>
            <FormattedMessage id="explore.zone.title" values={{ zone: zone.name }} />
          </Title>
          <Subtitle>
            <FormattedMessage id="explore.zone.title" values={{ zone: zone.name }} />
          </Subtitle>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
